export interface Anime {
  id: string;
  title: string;
  jpTitle: string;
  cover: string;
  banner: string;
  genres: string[];
  region: string;
  year: number;
  episodes: string;
  status: string;
  rating: number;
  heat: number;
  updatedAt: string;
  summary: string;
  intro: string[];
  reasons: string[];
  staff: { role: string; name: string }[];
  characters: { name: string; cv: string; desc: string }[];
  tags: string[];
  studio: string;
  dataProductShop?: boolean;
}

export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  cover: string;
  category: string;
  author: string;
  publishedAt: string;
  readCount: number;
  isHeadline: boolean;
  relatedAnimeIds: string[];
  content: { type: "paragraph" | "image" | "subtitle" | "quote"; text?: string; src?: string; caption?: string }[];
  tags: string[];
}

export const NEWS_CATEGORIES = [
  { key: "all", label: "全部资讯", desc: "全站动漫资讯", icon: "ri-newspaper-line" },
  { key: "新番情报", label: "新番情报", desc: "每季新作最新动向", icon: "ri-calendar-todo-line" },
  { key: "行业动态", label: "行业动态", desc: "制作公司与产业观察", icon: "ri-building-2-line" },
  { key: "剧场版", label: "剧场版", desc: "院线动画最新消息", icon: "ri-movie-2-line" },
  { key: "活动资讯", label: "活动资讯", desc: "漫展与线下活动", icon: "ri-ticket-2-line" },
  { key: "声优动态", label: "声优动态", desc: "声优与幕后故事", icon: "ri-mic-2-line" },
];

export const ANIME_GENRES = ["热血", "奇幻", "日常", "悬疑", "科幻", "恋爱", "治愈", "运动"];
export const ANIME_REGIONS = ["日本", "中国", "美国"];
export const ANIME_YEARS = [2025, 2024, 2023, 2022, 2021];